import BipolarAssessment from './BipolarAssessment';

export default BipolarAssessment;
